<template>
  <div class="vx-row mb-2">
    <div class="vx-col w-full">
      <vs-input
        class="w-full"
        v-validate="structure.validation"
        :label-placeholder="fieldLabel"
        v-model="localVal"
        name="field"
        @keyup="changeHandler()"
        @blur="onFieldBlur()"
        @focus="onFieldFocus()"
        :maxLength="structure.max"
        :minLength="structure.min"
      />
      <!-- <input
        type="text"
        v-model="displayValue"
        @blur="isInputActive = false"
        @focus="isInputActive = true"
      />-->
      <span class="text-danger text-sm" v-show="errors.has('field')">{{ errors.first('field') }}</span>
    </div>
  </div>
</template> 
<script>
import { sidebarMixin } from "../sidebarMixin";
export default {
  mixins: [sidebarMixin],
  props: {
    index: String,
    structure: {
      type: Object,
      default: () => {},
      required: true,
    },
    value: String,
    validation: "",
  },
  data() {
    return {
      tempVal: 0,
      localVal: "",
      name: "",
      isInputActive: false,
    };
  },

  methods: {
    changeHandler() {
      // this.$emit("error", this.errors.errors);
      this.$validator.validateAll().then((result) => {
        this.$emit("error", { index: this.index, value: result });
      });
      this.onFieldBlur();
    },
    onFieldFocus() {
      this.tempVal = this.localVal.replace("", "");
      if (isNaN(this.tempVal)) {
        this.localVal = "";
      }
      this.localVal = this.tempVal;
    },
    onFieldBlur() {
      if (this.localVal != "") {
        this.tempVal = parseFloat(this.localVal.replace(/[^\d\.]/g, ""));
        if (isNaN(this.tempVal)) {
          this.localVal = "";
        } else {
          this.localVal =
            " " +
            this.tempVal
              .toFixed(0)
              .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") +
            "";
        }
      }
    },
  },
  created() {
    //we emit the default value because if user does not touch it won't be captured in the array

    if (this.value == undefined) {
      this.localVal = this.structure.value;
    } else {
      this.localVal = this.value;
    }

    if (this.localVal != "") {
      this.$emit("error", { index: this.index, value: true });
      this.$emit("input", { index: this.index, value: this.localVal });
    }

    //trigger blurr
    this.onFieldBlur();

    this.$watch("localVal", (value) => {
      this.$emit("input", {
        index: this.index,
        value: value.split(",").join(""),
      });
    });
  },
};
</script>